import {
  getTawakkalnaUser,
  linkTawakkalnaUser
} from "./chunk-VNAI6LR7.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/auth/twk.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
var useGetTawakkalnaUser = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["twk-user"],
    queryFn: () => getTawakkalnaUser(props)
  }, options));
};
var useLinkTawakkalnaUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: linkTawakkalnaUser,
    onSuccess: (data) => {
      queryClient.setQueryData(["twk-user"], (oldData) => __spreadProps(__spreadValues({}, oldData), {
        email: data.email
      }));
    }
  });
};

export {
  useGetTawakkalnaUser,
  useLinkTawakkalnaUser
};
//# sourceMappingURL=chunk-EFDYMUN5.mjs.map